// Eventi della rete — modificare a mano per aggiornare la vetrina eventi.
export const EVENTS = [
  {
    id: "ev-01",
    titolo: "Networking Night — Storie di impresa",
    data: "2026-07-10",
    dataLabel: "10 Luglio 2026",
    ora: "19:00",
    luogo: "Palazzo Vitelli, Frosinone",
    formato: "In presenza",
    posti: 60,
    descrizione:
      "Sei imprenditrici raccontano il proprio percorso in dieci minuti. Networking guidato e aperitivo finale.",
  },
  {
    id: "ev-02",
    titolo: "Workshop: raccontare il brand sui social",
    data: "2026-07-24",
    dataLabel: "24 Luglio 2026",
    ora: "17:30",
    luogo: "Online su Zoom",
    formato: "Online",
    posti: 120,
    descrizione:
      "Un laboratorio pratico su come costruire una presenza Instagram autentica per la propria impresa.",
  },
  {
    id: "ev-03",
    titolo: "Mentorship Day — 1:1 con le socie senior",
    data: "2026-09-12",
    dataLabel: "12 Settembre 2026",
    ora: "10:00",
    luogo: "Spazio BC Next, Roma",
    formato: "In presenza",
    posti: 30,
    descrizione:
      "Sessioni individuali di 40 minuti con imprenditrici esperte: strategia, finanza, comunicazione.",
  },
  {
    id: "ev-04",
    titolo: "Assemblea annuale & premio Donna Impresa",
    data: "2026-11-08",
    dataLabel: "8 Novembre 2026",
    ora: "16:00",
    luogo: "Teatro Nestor, Frosinone",
    formato: "In presenza",
    posti: 200,
    descrizione:
      "Il momento più importante dell'anno: bilancio della rete, nuovi progetti e premiazione.",
  },
];

// Voci della community — testimonianze e obiettivi condivisi.
export const VOCI = [
  {
    id: 1,
    nome: "Giulia M.",
    ruolo: "Fondatrice, Atelier Rosa",
    obiettivo: "Aprire il secondo laboratorio entro il 2027",
    testo:
      "Ho iniziato con una macchina da cucire in salotto. Oggi guido un team di otto persone: crederci è stato il primo investimento.",
  },
  {
    id: 2,
    nome: "Sara D.",
    ruolo: "CEO, Kaleido Tech",
    obiettivo: "Portare più ragazze verso le professioni tech",
    testo:
      "Nelle riunioni ero spesso l'unica donna. Ho smesso di chiedere permesso e ho iniziato a costruire il tavolo.",
  },
  {
    id: 3,
    nome: "Elena B.",
    ruolo: "Titolare, Bottega Marè",
    obiettivo: "Trasformare la bottega in un marchio nazionale",
    testo:
      "La rete mi ha dato ciò che mancava: donne che avevano già superato lo stesso ostacolo e me lo hanno raccontato.",
  },
  {
    id: 4,
    nome: "Marta F.",
    ruolo: "Avvocata, Studio Legale Fiore",
    obiettivo: "Formare cento imprenditrici sui contratti",
    testo:
      "Condividere competenze non toglie spazio: moltiplica le possibilità. È così che una community diventa impresa.",
  },
];
